export enum RodoAgreement {
    ALL_AGR_04_2021='ALL_AGR_04_2021', // 04_2021
    GEN_EMAIL_NOTN='GEN_EMAIL_NOTN', // 04_2021
    GEN_SMS_NOTN='GEN_SMS_NOTN', // 04_2021
    GEN_EMAIL_MRKG='GEN_EMAIL_MRKG', // 04_2021
    ORG_EMAIL_MRKG='ORG_EMAIL_MRKG', // 04_2021
    ORG_SMS_MRKG='ORG_SMS_MRKG' // 04_2021
}